import { SectorsService, UserService } from '@shared/core';
import { Injectable } from '@angular/core';
import { SESSION, USER } from '../actions/index';
import { SectorsStopServiceAction } from '../actions/sectors-actions';
import { SessionDestroyAction, SessionInitAction } from '../actions/session-actions';
import { UserHydrateFailureAction, UserHydrateSuccessAction, UserStartServiceAction, UserStopServiceAction } from '../actions/user-actions';
import { UserVehiclesStopServiceAction } from '../actions/user-vehicles-actions';
import { Action } from '../action';
import { UserState } from '@shared/core';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { catchError, map, mergeMap, switchMap, takeUntil } from 'rxjs/operators';

@Injectable()
export class FireServicesEffects {
	@Effect({ dispatch: true })
	authStateLogoutSuccess$ = this.actions$.pipe(
		ofType<SessionDestroyAction>(SESSION.DESTROY),
		mergeMap(action => [
			new SectorsStopServiceAction(null, action.correlationId),
			new UserStopServiceAction(null, action.correlationId),
			new UserVehiclesStopServiceAction(null, action.correlationId)
		])
	);
	@Effect({ dispatch: true })
	authStateSuccess$ = this.actions$.pipe(
		ofType<SessionInitAction>(SESSION.INIT),
		mergeMap(action => [new UserStartServiceAction(null, action.correlationId)])
	);

	@Effect({ dispatch: true })
	hydrateUser$: Observable<Action> = this.actions$.pipe(
		ofType<UserStartServiceAction>(USER.START_SERVICE),
		switchMap(action =>
			this.users.hydrate().pipe(
				takeUntil(this.authStateLogoutSuccess$),
				map((user: UserState) => new UserHydrateSuccessAction(user, action.correlationId)),
				catchError(error => of(new UserHydrateFailureAction(error, action.correlationId)))
			)
		)
	);

	constructor(
		private actions$: Actions,
		private store: Store<any>,
		private sectors: SectorsService,
		private users: UserService
	) {}
}
